import { render, staticRenderFns } from "./MovieContentUpload.vue?vue&type=template&id=fa30dd0a&scoped=true&"
import script from "./MovieContentUpload.vue?vue&type=script&lang=ts&"
export * from "./MovieContentUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa30dd0a",
  null
  
)

export default component.exports